import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { SizeType } from '@cf/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
  selector: 'cf-input-label',
  templateUrl: 'label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgClass, NgxTolgeeModule],
})
export class LabelComponent {
  @Input() for!: string;

  @Input()
  optional!: boolean;

  @Input() size: SizeType = 'sm';

  weight = input<'500' | '600'>('600');

  labelClass = input<string>('');

  @Input()
  get required() {
    return this._required;
  }

  set required(value: any) {
    this._required = coerceBooleanProperty(value);
  }

  private _required!: boolean;
}
